import React, { useState, useEffect } from "react";
import { Container, Row, Col, Nav, Button, Offcanvas } from "react-bootstrap";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaCalendarCheck, FaHotel, FaHeart, FaBed, FaStar ,FaRegBell } from "react-icons/fa";
import "../css/Dashboard.css";
import { useTranslation } from "react-i18next";

function DashboardLayout() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
  },  [i18n.language, t]);


  const Sidebar = () => (
    <nav className="nav flex-column py-4">
      <h5
        className="px-3 mb-4 sidebar-title"
        onClick={() => {
          navigate("/dashboard");
          handleCloseSidebar();
        }}
        style={{ cursor: "pointer" }}
      >
        {t("myBooking")}
      </h5>
      <NavLink to="/dashboard" end className={({ isActive }) => "nav-link text-start " + (isActive ? "active" : "")} onClick={handleCloseSidebar}>
        <FaCalendarCheck className="me-2" />  {t("statusBooking")}
      </NavLink>
      <NavLink to="/dashboard/rooms" className={({ isActive }) => "nav-link text-start " + (isActive ? "active" : "")} onClick={handleCloseSidebar}>
        <FaHotel className="me-2" />  {t("roomType")}
      </NavLink>
      <NavLink to="/dashboard/favorite" className={({ isActive }) => "nav-link text-start " + (isActive ? "active" : "")} onClick={handleCloseSidebar}>
        <FaHeart className="me-2" />  {t("favorite")}
      </NavLink>
      <NavLink to="/dashboard/activities" className={({ isActive }) => "nav-link text-start " + (isActive ? "active" : "")} onClick={handleCloseSidebar}>
        <FaBed className="me-2" />  {t("activities")}
      </NavLink>
      <NavLink to="/dashboard/ratings" className={({ isActive }) => "nav-link text-start " + (isActive ? "active" : "")} onClick={handleCloseSidebar}>
        <FaStar className="me-2" />  {t("rating")}
      </NavLink>

      <NavLink to="/dashboard/notifications" className={({ isActive }) => "nav-link text-start " + (isActive ? "active" : "")} onClick={handleCloseSidebar}>
        <FaRegBell  className="me-2" />  {i18n.language === "ID" ? "Notifikasi" : t("notifications")}
      </NavLink>

      <hr />
    </nav>
  );
  

  return (
    <Container fluid className="dashboard-container">
      <Row>
        {!isMobile && (
          <Col md={3} lg={2} className="sidebar bg-white shadow-sm p-3">
            <Sidebar />
          </Col>
        )}

        {isMobile && (
          <Offcanvas show={showSidebar} onHide={handleCloseSidebar} responsive="md">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>{t("myBooking")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Sidebar />
            </Offcanvas.Body>
          </Offcanvas>
        )}

        <Col xs={12} md={9} lg={10} className="main-content p-4">
          {isMobile && (
            <div className="mb-3">
              <Button variant="outline-success" onClick={handleShowSidebar}>
                <FaBars /> Menu
              </Button>
            </div>
          )}
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export default DashboardLayout;
